import React from 'react';

import { styled, CHOICE_INDICATOR } from '../../common';
import type { ToggleProps } from './Toggle';
import { animationTransition } from '../../utils';
import { ThemedStyledProps, DefaultTheme } from 'styled-components';

const getBackgroundColor = ({ theme }: ThemedStyledProps<ToggleProps, DefaultTheme>) => theme.colors.mono14;

export const Indicator = styled.div`
  width: 64px;
  position: relative;
  height: 28px;
  border-radius: 60px;
  background-color: ${props => props.theme.colors.mono4};
  transition: ${animationTransition('background-color')};

  :before {
    background: #fff;
    position: absolute;
    content: ' ';
    display: block;
    border-radius: 12px;
    top: 50%;
    transform: translateY(-50%) translateZ(0.1px) translateX(2px);
    height: 24px;
    width: 40px;
    transition: ${animationTransition('transform')};
  }

  ${props => props.theme.mediaQueries.sm} {
    width: 56px;
    height: 24px;

    &:before {
      border-radius: 10px;
      height: 20px;
      width: 32px;
    }
  }
`;

const Input: React.FC<ToggleProps> = ({ children, alignIndicator, label, defaultChecked, hideLabel, ...props }) => (
  <input
    aria-checked={props.checked}
    onChange={props.onChange}
    {...props}
    defaultChecked={defaultChecked}
    type={'checkbox'}
  />
);

export const StyledInput = styled(Input)`
  :enabled {
    /* :focus ~ .${CHOICE_INDICATOR} {
      border-color: ${props => props.theme.colors.buttonPrimaryFillDark};
    }
    :hover ~ .${CHOICE_INDICATOR} {
      border-color: ${props => props.theme.colors.buttonPrimaryFillDark};
    }
    :active ~ .${CHOICE_INDICATOR} {
      background: red;
    } */
  }

  &:checked ~ ${Indicator} {
    background-color: ${props => getBackgroundColor(props)};
    &:before {
      transform: translateY(-50%) translateZ(0.1px) translateX(22px);

      ${props => props.theme.mediaQueries.sm} {
        transform: translateY(-50%) translateZ(0.1px) translateX(22px);
      }
    }
  }

  &:disabled ~ ${Indicator} {
    background-color: ${props => props.theme.colors.mono3};
    &:before {
      background: ${props => props.theme.colors.mono1};
    }
  }
`;
